import { usePrinterStore } from "application/contexts/printer/PrinterStore";
import { Dialog, Modal } from "@material-ui/core";
import {
  OrientationType,
  ResolutionType,
} from "application/contexts/screen/ScreenStore";
import { ReactComponent as Br } from "assets/icons/flags/br.svg";
import { ReactComponent as Es } from "assets/icons/flags/es.svg";
import { ReactComponent as Fr } from "assets/icons/flags/fr.svg";
import { ReactComponent as Pt } from "assets/icons/flags/pt.svg";
import { ReactComponent as Us } from "assets/icons/flags/us.svg";
import BottomModal from "components/bottomModal/BottomModal";
import enviroment from "corss-cutting/enviroment";
import React, { FC, useCallback, useEffect, useState } from "react";
import { LANGUAGE_OPTIONS, normalizeToI18n } from "i18n/languages";
import { Trans } from "react-i18next";
import { useShallow } from "zustand/react/shallow";
import meeLogo from "../../assets/images/logo-mee.png";
import meepLogo from "../../assets/images/logo-meep-white.png";
import PrintStatusModal from "./components/PrintStatusModal/PrintStatusModal";
import styles from "./Home.module.scss";
import { useHome } from "./UseHome";
import { ReactComponent as Click } from "assets/icons/click.svg";
import StartAction from "components/startAction/StartAction";
import CpfRegisterPage from "modules/cpfRegister/CpfRegisterPage";
import { getDeviceInfo } from "modules/reactNativeBridge/ReactNativeBridge";
import { PrinterStore } from "application/contexts/printer/PrinterStore";

export interface IHome {}

const Home: FC<IHome> = () => {
  const {
    kiosk,
    onClickLogo,
    wallpaper,
    startActions,
    showStartMenu,
    handleClickStart,
    handleCloseMenu,
    resolution,
    orientation,
    closeCpfRegister,
    cpfRegisterOpen,
    t,
    showLanguageModal,
    closeLanguageModal,
    handleChangeLanguage,
    openLanguageModal,
    language,
    refDiv,
  } = useHome();
  const [deviceSerial, setDeviceSerial] = useState<string>("");
  const [appVersion, setAppVersion] = useState<string>("");
  const [printModalClosedByUser, setPrintModalClosedByUser] = useState(false);

  const [ordersToPrint] = usePrinterStore(
    useShallow((state: PrinterStore) => [state.ordersToPrint])
  );
  const remainingPrints = ordersToPrint.length;
  const isPrinting = remainingPrints > 0;
  const showPrintModal = isPrinting && !printModalClosedByUser;

  const handleClosePrintModal = useCallback(() => {
    setPrintModalClosedByUser(true);
  }, []);

  useEffect(() => {
    if (!isPrinting) {
      setPrintModalClosedByUser(false);
    }
  }, [isPrinting]);

  useEffect(() => {
    const fetchDeviceInfo = async () => {
      try {
        if (!getDeviceInfo) {
          return;
        }
        
        const deviceInfo = await getDeviceInfo();
        
        if (deviceInfo) {
          if (deviceInfo.serialNumber && typeof deviceInfo.serialNumber === 'string') {
            setDeviceSerial(deviceInfo.serialNumber);
          }
          if (deviceInfo.appVersion && typeof deviceInfo.appVersion === 'string') {
            setAppVersion(deviceInfo.appVersion);
          }
        }
      } catch (error) {
        console.error("Erro ao obter informações do dispositivo:", error);
      }
    };

    fetchDeviceInfo();
  }, []);

  const renderFlag = useCallback((flag: string) => {
    switch (flag) {
      case "pt-BR":
        return <Br />;
      case "pt-PT":
        return <Pt />;
      case "en-US":
        return <Us />;
      case "es-ES":
        return <Es />;
      case "fr-FR":
        return <Fr />;
      default:
        return <Br />;
    }
  }, []);

  const renderButtons = useCallback(
    () =>
      startActions.map((props, key) => (
        <StartAction
          key={key}
          {...props}
          color={kiosk?.themeColor ?? kiosk?.primaryColor}
        />
      )),
    [kiosk, startActions]
  );

  return (
    <div id={styles.Home} onClick={handleClickStart} ref={refDiv}>
      <img
        src={wallpaper}
        alt="wallpaper"
        className={styles.wallpaper}
      />

      <div
        className={kiosk?.isMee || kiosk?.isMeeConsulting ? styles.meeLogo : styles.meepLogo}
        onClick={onClickLogo}
      >
        <img
          src={kiosk?.isMee || kiosk?.isMeeConsulting ? meeLogo : meepLogo}
          alt="logo"
        ></img>
      </div>

      <div
        className={styles.startButton}
        style={{ display: showStartMenu ? "none" : undefined }}
      >
        {kiosk?.barCodeMode ? (
          <>
            <span style={{ marginBottom: 20 }}>LEIA O CÓDIGO DE BARRAS</span>
          </>
        ) : (
          <>
            <Click />
            <span>{t("welcome")}</span>
          </>
        )}
      </div>

      <div className={styles.version}>{`${
        kiosk?.cefsharpVersion ? `${kiosk.cefsharpVersion} - ` : ""
      }${enviroment.appVersion}`}</div>
      {(deviceSerial || appVersion) && (
        <div className={styles.serial}>
          {deviceSerial && `Serial: ${deviceSerial}`}
          {deviceSerial && appVersion && " - "}
          {appVersion && `App Version: v${appVersion}`}
        </div>
      )}
      <Modal open={showStartMenu} onClose={handleCloseMenu}>
        <div
          className={styles.menu}
          style={{
            width:
              resolution === ResolutionType.FULL_HD
                ? orientation === OrientationType.PORTRAIT
                  ? 700
                  : 1200
                : orientation === OrientationType.PORTRAIT
                ? 700
                : 900,
            display:
              orientation === OrientationType.LANDSCAPE ? "grid" : "flex",
            gridTemplateColumns:
              orientation === OrientationType.LANDSCAPE ? "1fr 1fr" : undefined,
            gap:
              orientation === OrientationType.LANDSCAPE
                ? resolution === ResolutionType.FULL_HD
                  ? "50px"
                  : "25px"
                : undefined,
          }}
        >
          {renderButtons()}
        </div>
      </Modal>
      <BottomModal
        showModal={showLanguageModal}
        onClickClose={closeLanguageModal}
      >
        <div className={styles.languageModal}>
          <p>
            <Trans i18nKey="select_language">
              Selecione o <b>idioma</b>
            </Trans>
          </p>

          <div
            style={{
              gridTemplateColumns:
                orientation === OrientationType.LANDSCAPE
                  ? "repeat(3, 1fr)"
                  : "repeat(2, 1fr)",
            }}
          >
            {LANGUAGE_OPTIONS.map((opt) => (
              <div
                key={opt.code}
                onClick={(e) => handleChangeLanguage(e, opt.code)}
                className="langCard"
                aria-pressed={
                  normalizeToI18n(opt.code) ===
                  normalizeToI18n((language || "pt") as any)
                }
              >
                {renderFlag(opt.base)}
                <span>{opt.nativeLabel}</span>
              </div>
            ))}
          </div>
        </div>
      </BottomModal>
      <Dialog open={cpfRegisterOpen} onClose={closeCpfRegister}>
        <CpfRegisterPage onClose={closeCpfRegister} />
      </Dialog>
      <PrintStatusModal
        open={showPrintModal}
        onClose={handleClosePrintModal}
        remainingPrints={remainingPrints}
      />
      {kiosk?.enableTotemTranslation && (
        <div onClick={openLanguageModal} className={styles.languageButton}>
          {renderFlag(language ?? "")}
          {t("selected_language")}
        </div>
      )}
    </div>
  );
};

export default Home;
